import { atom } from "recoil"

const selectedAssignedCategoryIdState = atom({
  key:'selectedAssignedCategory',
  default:null
})

export default selectedAssignedCategoryIdState